<script setup>
import { useRoute, useRouter } from "vue-router";
import { setToken } from "@/utils/auth.js";
import { getTokenByHash } from "@/api/system/user.js";

import CanvasVerify from "@/components/CanvasVerify/index.vue";

const route = useRoute();
const router = useRouter();

//  test hash => a77da0d25ff1b10a4e39f0a9a9a552fb
//  server api
onMounted(async () => {
  // console.log(route.params.hash);
});

const login = async () => {
  const { hash } = route.params;

  if (!hash) {
    return;
  }

  const {
    data: { access_token }
  } = await getTokenByHash(hash);

  setToken(access_token);

  await router.push({ path: "/index", replace: true });
};
</script>

<template>
  <!--  访问链接：http://localhost:13336/customerCenter/asdsadasdsad  -->

  <el-result
    class="h-full"
    icon="success"
    title="成功导航到贝纳lims用户登录页"
    sub-title="请在滑动验证以登录"
  >
    <template #extra>
      <div class="bg-[rgb(111 114 185)] border-2 border-solid border-[#eee] p-4">
        <CanvasVerify @pass="login"></CanvasVerify>
      </div>
    </template>
  </el-result>
</template>

<style scoped lang="scss"></style>
